/* eslint-disable */

import WebPayments from '../../common/square/web-payments';
import a11yErrorHandler from './a11y-error-handler';
import CardRenderer from '../../common/square/card-renderer';
import cardStyles from '../../common/square/card-styles';
import helpers from '../../common/square/helpers';
import jQuery from 'jquery';
/**
 * Handles the frontend logic of the add-on.
 */
export default class FrontEndHandler {
	constructor( args ) {
		for ( const prop in args ) {
			if ( args.hasOwnProperty( prop ) ) {
				this[ prop ] = args[ prop ];
			}
		}

		this.fields = {
			cardNumber: 1,
			expirationDate: 1,
			cvv: 1,
			postalCode: 1,
			cardHolderName: 3,
		};

		this.cardStyles = cardStyles( this.formId, this.pageInstance );

		this.errorStack = new a11yErrorHandler( this.fields, this.formId, this.ccFieldId );
		this.webPayments = new WebPayments( this.formId, this.application_id, this.location_id );
		this.cardRenderer = new CardRenderer( this.webPayments, this.errorStack, this.formId, 0, this.ccFieldId, this.cardStyles, 'front', gforms_square_theme_strings );
		helpers.formId = this.formId;
		this.cacheElements();
		this.bindEvents();
		this.cardRenderer.render();
	}

	/**
	 * @function cacheElements
	 * @description Caches the elements used in the process of creating and submitting the form.
	 *
	 * @since 1.7
	 *
	 */
	cacheElements() {
		this.form = jQuery( '#gform_' + this.formId );
		this.GFSField = jQuery( '#input_' + this.formId + '_' + this.ccFieldId );
		this.GFSCCInput = jQuery( '#input_' + this.formId + '_' + this.ccFieldId + '_1' );
		this.fieldContainer = jQuery( '.ginput_container_square_card' );
	}

	/**
	 * @function bindEvents
	 * @description Binds events handlers for the form and feed conditional logic.
	 *
	 * @since 1.7
	 *
	 */
	bindEvents() {
		// After feeds are evaluated, handle square feed if it exists and active.
		gform.addAction(
			'gform_frontend_feeds_evaluated',
			this.handleFeedEvaluated.bind( this )
		);

		// bind Square functionality to submit event.
		jQuery( '#gform_' + this.formId ).on(
			'submit',
			this.handleFormSubmit.bind( this )
		);

		// Set priority to 51 so it will be triggered after the coupons add-on
		gform.addFilter( 'gform_product_total', function( total, formId ) {
			window[ 'gform_square_amount_' + formId ] = total;
			return total;
		}, 51 );
	}

	/**
	 * @function handleFeedEvaluated
	 * @description Handles showing/hiding the field after feed conditional logic is evaluated.
	 *
	 * @since 1.0.0
	 *
	 * @param {Array}   feeds  All feeds that were evaluated.
	 * @param {Integer} formId The id of the form.
	 *
	 */
	handleFeedEvaluated( feeds, formId ) {
		if ( formId != parseInt( this.formId ) ) {
			return;
		}

		this.activeFeed = null;
		this.feedActivated = false;
		// Loop through the feeds and Check if square feed is active.
		const feedsCount = Object.keys( feeds ).length;
		for ( let i = 0; i < feedsCount; i++ ) {
			if ( feeds[ i ].addonSlug === 'gravityformssquare' && feeds[ i ].isActivated ) {
				this.feedHasConditionalLogic = feeds[ i ].conditionalLogic;
				this.feedActivated = true;
				// Add the active feed object to the square object as it will be needed later.
				this.activeFeed = this.feeds[ feeds[ i ].feedId ];

				// check if we are in the cc page, if so initiate the Square single element payment form.
				if ( helpers.isCreditCardOnPage( this.ccPage ) ) {
					this.feedConditionalLogicResult = true;
				}

				break; // allow only one active feed.
			}
		}

		// If no active feeds found, display error next to Square Card Field.
		if ( ! this.feedActivated ) {
			this.feedConditionalLogicResult = false;
			// Show error.
			this.errorStack.push( 'generic', gforms_square_theme_strings.no_active_frontend_feed );
			// Hide inputs.
			this.fieldContainer.hide();
			// remove square fields and form status when Square feed deactivated.
			helpers.resetSquareStatus( this.form, formId );
			helpers.resetFormStatus( this.form, formId );
			this.activeFeed = null;
		} else {
			this.errorStack.remove( 'generic' );
			this.fieldContainer.show();
		}
	}

	/**
	 * @function handleFormSubmit
	 * @description Handles form submission by validating the name and tokenizing the card.
	 *
	 * @since 1.7
	 *
	 * @param {object} event The form submission event.
	 *
	 * @return {Promise<boolean>}
	 */
	async handleFormSubmit( event ) {
		if ( ! this.canSubmitToSquare() ) {
			return true;
		}

		this.form.data( 'gfsquaresubmitting', true );
		helpers.maybeAddSpinner( false, this.formId );

		this.form = jQuery( '#gform_' + this.formId );

		helpers.updatePaymentAmount( this.formId, this.activeFeed );

		// Skip square logic if clicking on the Previous button, not the right page or if total amount is 0.
		const sourcePage = parseInt( jQuery( '#gform_source_page_number_' + this.formId ).val(), 10 ),
			targetPage = parseInt( jQuery( '#gform_target_page_number_' + this.formId ).val(), 10 ),
			skipSqFormHandler = false;

		if ( ( sourcePage > targetPage && targetPage !== 0 ) || window[ 'gform_square_amount_' + this.formId ] === 0 ) {
			skipSqFormHandler = true;
		}

		if ( ( helpers.isLastPage() && ! helpers.isCreditCardOnPage() ) || gformIsHidden( this.GFSCCInput ) || skipSqFormHandler ) {
			return true;
		}

		event.preventDefault();

		// Get the cardholder first and last name to make sure we can start SCA later.
		const fullName = jQuery( '#input_' + this.formId + '_' + this.ccFieldId + '_' + this.fields.cardHolderName.toString() ).val(),
			names = fullName.trim().split( ' ' );

		// If we don't have a name show error and stop execution.
		if ( names.length < 2 ) {
			this.errorStack.push( 'cardHolderName', gforms_square_theme_strings.requires_name );
			helpers.resetFormStatus( this.form, this.formId );
			return false;
		}

		this.errorStack.remove( 'cardHolderName' );

		helpers.resetSquareStatus();

		try {
			this.tokenizedCard = await this.webPayments.getTokenizeCard();

			if ( this.tokenizedCard.status === 'OK' ) {
				this.nonceReceived( this.tokenizedCard.token, this.tokenizedCard.details.card );
			} else {
				if ( this.tokenizedCard.errors.length > 0 ) {
					this.tokenizedCard.errors.forEach( ( error ) => {
						this.errorStack.push( error.field, error.message );
					} );
				}

				helpers.resetFormStatus( this.form, this.formId );
			}
		} catch ( e ) {
			this.errorStack.push( 'generic', gforms_square_theme_strings.CATCH_ALL );
			helpers.resetFormStatus( this.form, this.formId );
		}

		return false;
	}

	/**
	 * @function nonceReceived
	 * @description Fired when the nonce received from Square after calling getCardNonce
	 *
	 * @since 1.0.0
	 *
	 * @since 1.7.0 Moved error handling to form submission handler.
	 *
	 * @param {string} nonce    The card token.
	 * @param {object} cardData The card data object that contains information like last 4
	 *
	 * @return {Promise<boolean>}
	 */
	async nonceReceived( nonce, cardData ) {
		this.errorStack.clearErrors();
		// Add card data to hidden inputs so they can be saved with the entry.
		this.form.append( jQuery( '<input type="hidden" name="square_credit_card_last_four" id="' + this.formId + '_square_credit_card_last_four" />' ).val( cardData.last4 ) );
		this.form.append( jQuery( '<input type="hidden" name="square_credit_card_type" id="' + this.formId + '_square_credit_card_type"/>' ).val( cardData.brand ) );
		this.form.append( jQuery( '<input type="hidden" name="square_nonce" id="' + this.formId + '_square_nonce" />' ).val( nonce ) );
		// If we already have a nonce, start SCA, If SCA Passes, form will be submitted.
		await this.startSCA( nonce );
	}

	/**
	 * @function startSCA
	 * @description Starts SCA process, if not required, will submit the form.
	 *
	 * @param {string} nonce The card token.
	 *
	 * @since 1.0.0
	 *
	 * @return boolean
	 */
	async startSCA( nonce ) {
		// Get the cardholder first and last name to start SCA.
		const full_name = jQuery( '#input_' + this.formId + '_' + this.ccFieldId + '_3' ).val();
		const names = full_name.trim().split( ' ' );
		// If we don't have a name show error and stop execution.
		if ( names.length < 2 ) {
			this.errorStack.push( 'cardHolderName', gforms_square_theme_strings.requires_name );
			this.resetFormStatus( this.form, this.formId, this.isLastPage() );
			return false;
		}
		this.errorStack.remove( 'cardHolderName' );

		const first_name = names[ 0 ];
		const last_name = names[ 1 ];

		// Prepare any given billing information to be provided along with the names for SCA.
		const email = GFMergeTag.replaceMergeTags( this.formId, helpers.getBillingAddressMergeTag( this.activeFeed.email ) );
		const city = GFMergeTag.replaceMergeTags( this.formId, helpers.getBillingAddressMergeTag( this.activeFeed.address_city ) );
		const postalCode = GFMergeTag.replaceMergeTags( this.formId, helpers.getBillingAddressMergeTag( this.activeFeed.address_zip ) );
		const addressLine1 = GFMergeTag.replaceMergeTags( this.formId, helpers.getBillingAddressMergeTag( this.activeFeed.address_line1 ) );
		const addressLine2 = GFMergeTag.replaceMergeTags( this.formId, helpers.getBillingAddressMergeTag( this.activeFeed.address_line2 ) );

		// Collect rest of verification data if we have minimum required details.
		if ( first_name === '' || last_name === '' ) {
			// We don't have enough data to start SCA
			// This part should be implemented later when hiding cardholder name field becomes an option.
			return false;
		}

		const billingContact = {
			givenName: first_name,
			familyName: last_name,
		};

		// Add only available billing information to contact object.
		if ( email !== '' ) {
			billingContact.email = email;
		}

		if ( city !== '' ) {
			billingContact.city = city;
		}

		if ( postalCode !== '' ) {
			billingContact.postalCode = postalCode;
		}

		if ( addressLine1 !== '' ) {
			billingContact.addressLines = [];
			billingContact.addressLines.push( addressLine1 );
		}

		if ( addressLine2 !== '' ) {
			billingContact.addressLines.push( addressLine2 );
		}

		const verificationDetails = {
			intent: 'CHARGE',
			amount: window[ 'gform_square_amount_' + this.formId ].toString(),
			currencyCode: this.currency,
			billingContact,
		};
		// Start SCA.
		try {
			const verificationResults = await this.webPayments.getPaymentsApi().verifyBuyer(
				nonce,
				verificationDetails
			);

			this.form.append( jQuery( '<input type="hidden" name="square_verification" id="' + this.formId + '_square_verification" />' ).val( verificationResults.token ) );
			this.form.submit();
		} catch ( e ) {
			this.errorStack.push( 'generic', gforms_square_theme_strings.sca );
			helpers.resetFormStatus( this.form, this.formId );
		}
	}

	/**
	 * Checks if the form can be submitted or not.
	 *
	 * @since 1.0.0
	 *
	 * @return {boolean}
	 */
	canSubmitToSquare() {
		// We cannot submit to Square if any of the cases are true.
		switch ( true ) {
			// Field is not currently shown.
			case ! this.GFSCCInput.is( ':visible' ):
			case gformIsHidden( this.GFSCCInput ):
			case ! helpers.isCreditCardOnPage( this.ccPage ):
				return false;
			// No active Square feed.
			case ! this.feedActivated:
				return false;
			// Already submitting.
			case this.form.data( 'gfsquaresubmitting' ):
				return false;
			// Saving.
			case jQuery( '#gform_save_' + this.formId ).val() == 1:
				return false;
			// reCAPTCHA is pending a result.
			case typeof gformIsRecaptchaPending !== 'undefined' && gformIsRecaptchaPending( this.form ):
				return false;
			default:
				return true;
		}
	}
}
